import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import PropTypes from 'prop-types';
import MediaQueries, {breakpoint} from '~/constants/MediaQueries';
import {metrics} from '~/vendor/metrics';
// components
import ContentCard from '~/components/ContentCard';
import OrderOptions from '~/components/OrderOptions';
import {routerPropTypes} from '~/router/withRouter';
import {useNavigate} from 'react-router-dom';
import {
  simplePricingTestEnabled,
  wtoTestEnabled
} from '~/selectors/ConfigSelectors';
import {ga4event} from '~/utils/analytics';

import './index.scss';

const propTypes = {
  backPath: PropTypes.string,
  nextFundraiser: PropTypes.func,
  router: routerPropTypes,
  setSkipOverview: PropTypes.func,
  skipOverview: PropTypes.bool,
  onClose: PropTypes.func
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function NextMenu({onClose, backPath = '/next'}) {
  const navigate = useNavigate();
  const isDesktop = breakpoint(MediaQueries.largeAndAbove);
  const simplePricingEnabled = useSelector(simplePricingTestEnabled);
  const isWtoTestEnabled = useSelector(wtoTestEnabled);

  useEffect(() => {
    metrics.fireEvent('lab ways to order', 'order options');
  }, []);

  const navBack = () => {
    ga4event({
      event: 'lab_interaction',
      lab_interaction_location: 'lab_quote_options',
      lab_interaction_type: 'back arrow'
    });
    // once simple pricing/WTO wins/loses, we wont have nested ifs, so ignore this for now
    if (simplePricingEnabled) {
      navigate('/next/order-type');
    } else if (isWtoTestEnabled) {
      navigate('/');
    } else {
      navigate(backPath);
    }
  };

  return (
    <ContentCard
      data-testid="next-menu"
      onNavBack={navBack}
      onNavClose={onClose}
      title={isDesktop ? 'Ordering Options' : 'Next'}>
      <OrderOptions />
    </ContentCard>
  );
}

NextMenu.propTypes = propTypes;
